
import { every } from 'lodash-es'
import { Component, Mixins, Watch } from 'vue-property-decorator'
import ReferralModalConditions from '~/components/common/referralModal-conditions'
import ReferralModal from '~/components/common/modals/ReferralModal.vue'

@Component
export default class ReferralModalProvider extends Mixins(ReferralModalConditions) {
  @Watch('$store.state.initialized', { immediate: true })
  maybeShowReferralModal(isInitialized: boolean) {
    if (!isInitialized) { return }

    const modalConditions = this.referralModalVisibilityConditions

    if (every(modalConditions)) {
      this.$modal.show(ReferralModal, {}, {
        name: 'ReferralModal',
        width: 516,
        classes: 'my-xxl'
      }, {
        opened: () => {
          this.$cookies.set('referral-modal-seen', true)
        }
      })
    }
  }
}
